import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables'
import { useFieldView } from './FieldViewState'
import FieldViewReadonlyLocation from './FieldViewReadonlyLocation.vue'
import FieldViewReadonlyResource from './FieldViewReadonlyResource.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldViewInfoPanel',
  props: {
    id: null,
    source: null
  },
  setup(__props: any) {



const router = useRouter()

const { setSelectedLocation, setSelectedResource } = useFieldView()

function handleDismiss() {
  setSelectedLocation(null)
  setSelectedResource(null)
  router.replace({ name: 'field-view-next', hash: router.currentRoute.hash })
}

return { __sfc: true,router, setSelectedLocation, setSelectedResource, handleDismiss, FieldViewReadonlyLocation, FieldViewReadonlyResource }
}

})